<div class="container" [ngClass]="{'dark' : !isFordPass}">
  <div class="content">
    @if (isFordPass) {
    <div class="content__fordpass-template">
      <div class="content__fordpass-template__warning" title="Warning"></div>
      <h2>{{'logout.fordpass.title'| translate}}</h2>
      <p>{{'logout.fordpass.subtitle' | translate}}</p>
      <br />
      <p>{{'logout.fordpass.text' | translate}}</p>
    </div>
    } @else {
    <div class="content__web-template">
      <div class="content__web-template__modal">
        <h2>{{'logout.web.title'| translate}}</h2>
        <p>{{'logout.web.subtitle' | translate}}</p>
        <p>{{'logout.web.text' | translate}}</p>
        <br />
        <lib-button type="primary" [rightIcon]="true" (clickButton)="doLogout()">{{'logout.action.button' | translate}}</lib-button>
      </div>
    </div>
    }
  </div>
</div>
